import BusinessLoanHistory from './BusinessLoanHistory';

export default BusinessLoanHistory;
